// extracted by mini-css-extract-plugin
module.exports = {"head":"Kses_head__gq6nd","row":"Kses_row__188eV","openKsLabel":"Kses_openKsLabel__c5bs0"};